import {initialState} from "../initialState";
import {SET_OPEN_BATTERY} from "../actionTypes/open";


const openReducer = (state = initialState.open, action) => {
    switch (action.type) {
        case SET_OPEN_BATTERY:
            return {
                ...state,
                batteryId: action.payload
            }
        default:
            return state
    }
}

export default openReducer


// SELECTORS

// export const openBatteryStateSelector = state => state.open.batteryState

export const openBatteryInMyBatteriesSelector = state => state.myBatteries.batteries.find(b => b.battery_id === state.open.batteryId)
export const openBatteryInBleSelector = state => state.connection.bleAvailable.find(b => b.id === state.open.batteryId)

export const openBatterySelector = state => openBatteryInMyBatteriesSelector(state)/*|openBatteryInBleSelector(state)*/
export const openBatteryIdSelector = state => state.open.batteryId